import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";

export function AuthCallback() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!auth.isLoading && auth.isAuthenticated) navigate("/", { replace: true });
  }, [auth.isLoading, auth.isAuthenticated, navigate]);

  if (auth.error) {
    return (
      <div className="flex min-h-full items-center justify-center text-rose-300">
        Sign-in failed: {auth.error.message}
      </div>
    );
  }
  return (
    <div className="flex min-h-full items-center justify-center text-slate-300">
      Completing sign-in…
    </div>
  );
}
